import React, {useRef} from "react";
import {Tooltip} from 'primereact/tooltip';
import {Toast} from "primereact/toast";

export default function Contact(params) {

    // console.log(params.model.phones[0])
    const toast = useRef()


    if (params.model.phones.length > 0) {
        let phone = (params.model.phones[0].phone_code ? params.model.phones[0].phone_code : '') + params.model.phones[0].phone
        return (
            <>
                <Toast ref={toast}/>
                <Tooltip target={".contact-item-" + params.model.id} position={'left'} mouseTrack mouseTrackLeft={10}/>
                <div className={'d-flex align-items-center gap-2'}
                     >
                    <div onClick={() => {navigator.clipboard.writeText(phone);   toast.current.show({severity: 'info', summary: 'Номер скопирован в буфер обмена.', life: 3000});}} className={'d-flex align-items-center gap-2 contact-item-' + params.model.id} data-pr-tooltip={phone}>
                        {params.model.phones &&
                            <i className={'pi pi-phone'}></i>
                        }
                        <span>{params.model.name}</span>
                    </div>
                </div>
            </>
        )
    } else {
        return 'Нет контактов'
    }
}